module.exports = __webpack_public_path__ + "static/blink_pharma-18c1e058773e7aa21b3fe5ed7c99b826.png";